var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-drr',{ref:"widget",staticClass:"widget-container",style:({
    zIndex: _vm.zIndex
  }),attrs:{"parent":true,"rotatable":false,"w":_vm.w,"h":_vm.h,"x":_vm.x,"y":_vm.y},on:{"dragstop":_vm.dragStop,"resizestop":_vm.resizeStop}},[_c('div',{staticClass:"ticky-wrap",style:({
      backgroundColor: _vm.backgroundColor
    }),attrs:{"id":("widget" + _vm.id)},on:{"click":_vm.setActiveWidget}},[_c('div',{staticClass:"ticky",style:({
        animationDuration: _vm.animationDuration + 's'
      })},_vm._l((_vm.feeds),function(feed){return _c('div',{key:feed,staticClass:"ticky-item ml-3 mr-3",style:({
          color: _vm.color,
          fontSize: _vm.fontSize + 'px',
          lineHeight: _vm.h + 'px'
        })},[_vm._v(" "+_vm._s(feed)+" ")])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }